import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-no-autorizado',
  templateUrl: './no-autorizado.component.html',
  styles: [
  ]
})
export class NoAutorizadoComponent implements OnInit {

  constructor( private router:Router ) { }

  ngOnInit(): void {
  }
  volver(){
    this.router.navigate(['ofertas']);
  }

}
